import { difference as _difference } from 'lodash';

export default function (accessRoles, userScopes) {
  return _difference(accessRoles, userScopes).length === 0;
}
